import './Chart.css';

const Chart = () => {

    return (

        <div className="chart-box">

            <div className="chart-top">

                <h2>Ticket Sales</h2>

                <p>+24%</p>

            </div>

            <div className="bars">

                <div className="single-bar">

                    <div className="bar bar1"></div>

                    <span>Jan</span>

                </div>


                <div className="single-bar">

                    <div className="bar bar2"></div>

                    <span>Feb</span>

                </div>


                <div className="single-bar">

                    <div className="bar bar3"></div>

                    <span>Mar</span>

                </div>


                <div className="single-bar">

                    <div className="bar bar4"></div>

                    <span>Apr</span>

                </div>


                <div className="single-bar">

                    <div className="bar bar5"></div>

                    <span>May</span>

                </div>

            </div>

        </div>

    );
}

export default Chart;